<template>
	<div>
        <div :class="`${rowClass} h-100`">
            <div :class="`${colClass} h-100`">
                <b-table
                    ref="table"
                    class="bg-white"
                    small
                    fixed
                    responsive
                    show-empty
                    :items="items"
                    >
                        <template #empty>
                            <p align="center">{{ trans('none') }}</p>
                        </template>
                </b-table>
            </div>
        </div>
	</div>
</template>

<script>
export default {
	props: {
		block: Object,
	},
	data() {
		return {
			trans: trans,
            items: this.block && this.block.meta ? this.excelToTable(this.block.meta.json) : []
		}
	},
    watch: {
        block() {
            this.items = this.block && this.block.meta ? this.excelToTable(this.block.meta.json) : []
        }
    },
    computed: {
      rowClass() {
        return this.block.span_row ? _.getRowClass(this.block) : null
      },
      colClass() {
        return this.block.span_row ? _.getColClass(this.block) : null
      },
    },
    methods: {
        excelToTable(values) {
            if (!values || !Array.isArray(values)) return [];

            let headers = values[0] ?? []
            let json = [];
            for (let i = 1; i < values.length; i++) {
                const temp = {};
                for (let j = 0; j < headers.length; j++) {
                    if (headers[j]) {
                        temp[headers[j]] = values[i][j];
                    }
                }
                json.push(temp);
            }
            return json;
        }
    },
}
</script>